module.exports = __webpack_public_path__ + "img/work2021Survey.c53b1f50.png";